<template>
  <div class="usp-app-map" data-ani="aniGroup" v-if="moduleData.gif">
    <!-- <div class="usp-app-map-text">
      <div class="usp-app-map-title h1-vw">NEDC 643KM</div>
      <div class="usp-app-map-desc">跨省级续航</div>
    </div> -->
    <div class="usp-app-map-gif">
      <img :src="moduleData.gif" alt="">
      <!-- <video
        preload
        muted="muted"
        class="usp-video pc map-video"
        webkit-playsinline
        playsinline
        poster="https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud%2FbackendUpload%2F20210630141007472-pc+_%3F%3F%3F%3F.png"
      >
        <source
          src="https://test-azure-community.obs.cn-south-1.myhuaweicloud.com/20210630113241%2F833f03ae33f44a78adc2b8ce9bda6e8d.mp4"
          type="video/mp4"
        />
      </video>
      <video
        preload
        muted="muted"
        class="usp-video inPad map-video"
        webkit-playsinline
        playsinline
        poster="https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud%2FbackendUpload%2F20210630141007828-iapd_%3F%3F%3F%3F.png"
      >
        <source
          src="https://test-azure-community.obs.cn-south-1.myhuaweicloud.com/20210629145400%2Ff6542b4d40eb42ce9b73b9677fff852a.mp4"
          type="video/mp4"
        />
      </video> -->
    </div>
  </div>
</template>
<script>
export default {
  name: "mapScreen",
  props:{
    moduleData:{
      type:Object
    }
  },
  data(){
    return {
      hide:"hide"
    }
  },
  mounted(){
    
  },
  methods:{
    
  }
}
</script>
<style lang="scss">
@import "@style/base";
@import "@style/common";
.usp-app-map-text {
    position: absolute;
    left: 0;
    right: 0;
    top: vw(100);
    z-index: 1;
    @include media(
      (
        $home-md: (
          position: static,
          left: auto,
          right: auto,
          top: auto
        )
      )
    );
    .usp-app-map-title {
      text-align: center;
      @include media(
        (
          $home-md: (
            margin-bottom: 10px,
            font-size: 36px,
            line-height: 48px
          ),
          $home-sm: (
            font-size: 28px,
            line-height: 42px
          )
        )
      );
    }
    .usp-app-map-desc {
      margin-top: 10px;
      margin-bottom: 40px;
      text-align: center;
      @include media(
        (
          $home-md: (
            font-size: 14px,
            line-height: 30px
          ),
          $home-sm: (
            margin-bottom: 30px
          )
        )
      );
    }
  }
  .usp-app-map-gif{
    img{
      width: 100%;
    }
  }
</style>